module.exports = __webpack_public_path__ + "public/img/sellwell.dfccbcda.png";